import React from 'react';
import styles from './Checkbox.module.scss';
import { Icon } from '../Icon';

const Checkbox = ({ onClick, checked, className, list }) => {
  return (
    <div className={className || styles.checkbox} onClick={onClick}>
      {list ? (
        <div className={checked ? styles.listIndicator : ''}>{checked ? <Icon src="vector" /> : null}</div>
      ) : (
        <div className={checked ? styles.indicator : styles.border}>{checked ? <Icon src="vector" /> : null}</div>
      )}
    </div>
  );
};

export default Checkbox;
